import { faPlus } from '@fortawesome/pro-regular-svg-icons'
import { Button } from '@mantine/core'

import { useQueryGetStoreDetails } from '@flecto/core/saas'
import { useTranslation } from '@flecto/translations'
import { CollapsibleCard, Icon } from '@flecto/ui'

import { useModalAddress, TableAddresses } from '../../../profile-address'
import { FormImages } from '../FormStoreSettings/FormImages'
import { FormSection } from '../FormStoreSettings/FormSection'

export function CardStoreAddresses() {
  const { t } = useTranslation('saas', { keyPrefix: 'profile_store' })

  const { data: store, isLoading, refetch } = useQueryGetStoreDetails()

  const { openModal } = useModalAddress({
    onSuccess: (_) => refetch(),
  })

  return (
    <FormSection>
      <CollapsibleCard opened>
        <CollapsibleCard.Title>
          {t('section_addresses.title')}
        </CollapsibleCard.Title>
        <CollapsibleCard.Description>
          {t('section_addresses.description')}
        </CollapsibleCard.Description>
        <CollapsibleCard.Content>
          <TableAddresses
            mt='sm'
            addresses={store?.open_to_public_addresses}
            isLoading={isLoading}
            withBorder={false}
          />
          <Button
            mt='sm'
            variant='outline'
            size='sm'
            leftSection={<Icon icon={faPlus} />}
            onClick={() =>
              openModal({
                address: {
                  open_to_public: true,
                  operating_hours_type: 'weekdays',
                },
              })
            }
          >
            {t('section_addresses.add_address')}
          </Button>
        </CollapsibleCard.Content>
      </CollapsibleCard>
      <FormImages images={[require('./image.jpeg')]} />
    </FormSection>
  )
}
